import React, { useEffect, useState } from 'react';
import SignUpForm from 'components/sign-up-form/SignUpForm';
import CodeForm from 'components/code-form/CodeForm';
import ROUTES from 'constants/routes';
import { useHistory } from 'react-router-dom';
import { useAuthState } from 'utils/auth-state';
import NewSignupForm from 'components/new-sign-up-form/NewSignupForm';

export default function NewSignupPage(p: { onSuccess?: () => void }) {
  return <SignUpWizard {...p} />;
}

export function SignUpWizard(p: {
  title?: string | false;
  signInLink?: string;
  onSuccess?: (p: {
    isProfileUpdated: boolean;
    hasOrg: boolean;
    hasLocation: boolean;
  }) => void;
  communityId?: string;
}) {
  const [email, setEmail] = useState('');
  const [didSendCode, setSendCode] = useState(false);
  const history = useHistory();
  useEffect(() => {
    loadNextPages();
  }, []);

  return (
    <>
      <NewSignupForm
        communityId={p.communityId}
        title={p.title}
        signInLink={p.signInLink}
        onSubmit={({ email }) => {
          setEmail(email);
        }}
        onSuccess={() => {
          setSendCode(true);
        }}
        onError={() => {
          setSendCode(false);
        }}
        variant={'signUp'}
      />
    </>
  );

  async function loadNextPages() {
    await import('components/location-setup-page/LocationSetupPage');
    await import('components/community-setup/CommunitySetupInitPage');
    await import('components/profile-update-page/ProfileUpdatePage');
  }
}
